export default "__VITE_ASSET__BNCRJg8___"